import { RELEASE } from "../../constants/testIds";

export const LiveBadge = ({ count }) => {
  return (
    <div id="live" hidden={count === null || count === undefined} data-testid={RELEASE.liveBadge}>
      <span className="dot"></span>
      <span id="liveN" data-testid={RELEASE.liveCount}>{count ?? "–"}</span>
      <span className="lbl">listening</span>
    </div>
  );
};
